// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2544":"f0fca6da","3214":"521c3f1b","4428":"521c3f1b","9503":"fec9a9c3"}[chunkId] + ".chunk.css";
};